import GuestDetailsLayout from './GuestDetailsLayout';

export default GuestDetailsLayout;
